export interface Vehicle {
  id: string;
  name: string;
  category: 'Business' | 'First' | 'Group';
  description: string;
  passengers: number;
  luggage: number;
  image: string;
  features: string[];
}

export interface Service {
  id: string;
  title: string;
  description: string;
  icon: React.ComponentType<any>;
}

export enum RoutePath {
  HOME = '/',
  FLEET = '/flotte',
  SERVICES = '/services',
  TRANSFERS = '/transferts',
  LAUSANNE = '/lausanne',
  ABOUT = '/a-propos',
  BOOKING = '/reservation',
  CONTACT = '/contact',

}